import { connect } from 'react-redux';
import ConsultaMultasRenainf from './consultaMultasRenainf';

export default connect()(ConsultaMultasRenainf);
